import  { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { AlertColor, SelectChangeEvent } from "@mui/material";
import { UserPermission } from "../../../../model/UserModel";
import { Group, GroupPermission } from "../../../../model/GroupModel";
import { User } from "../../../../model/OrganizationModel";
import PrivilegesStateDefault from "../../../WorkSpace/Permissions/components/PrivilegesStateDefault";
import PrivilegesStateAddingUser from "../../../WorkSpace/Permissions/components/PrivilegesStateAddingUser";
import PrivilegeStateEditingUser from "../../../WorkSpace/Permissions/components/PrivilegeStateEditingUser";
import PrivilegesStateAddingGroups from "../../../WorkSpace/Permissions/components/PrivilegesStateAddingGroups";
import PrivilegeStateEditingGroup from "../../../WorkSpace/Permissions/components/PrivilegeStateEditingGroup";
import { KeyDriveDialog } from "../../../../components/KeydriveComponents/Dialog/KeyDriveDialog";
import { Delete } from "@mui/icons-material";
import KeydriveSnackbar from "../../../../components/KeydriveComponents/Snackbar/KeydriveSnackbar";
import { AddPermissionGroup, AddPermissionUser, RemovePermissionGroup, RemovePermissionUser } from "../../../../services/Item/ItemServicesCRUD";
import { GetFolderGroupName, GetFolderInformation, GetItemUser, GetItemUserAllName, GetOneItem } from "../../../../services/Item/ItemServicesGet";
import { GetOrganizationGroup, GetOrganizationUserName } from "../../../../services/OrganizationServices";
import { FolderInformation, WorkSpaceUserName } from "../../../../model/ItemModel";
import { PermissionTargetType } from "../../../../enums/PermissionTargetType";

export type StatePrivilegesTypes = "default" | "adding user" | "adding group" | "editing user" | "editing group" | "deleting permission";

const PermissionUserFolder  = () => {
  const { nameOrg, idFolder } = useParams();
  const [item, setItem] = useState<WorkSpaceUserName>({} as WorkSpaceUserName)
  const [message, setMessage] = useState<string | undefined>(undefined);
  const [severity, setSeverity] = useState<AlertColor>("success");
  const navigate = useNavigate();
  const [targetType, setTargetType] = useState<PermissionTargetType>(PermissionTargetType.User);
  const [skip, setSkip] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [searchFilter, setSearchFilter] = useState<string>("");
  const [allUsers, setAllUsers] = useState<UserPermission[]>([]);
  const [allUsersMemory, setAllUsersMemory] = useState<UserPermission[]>([]);
  const [allGroups, setAllGroups] = useState<GroupPermission[]>([]);
  const [allGroupsMemory, setAllGroupsMemory] = useState<GroupPermission[]>([]);
  const [loadingUsers, setLoadingUsers] = useState<boolean>(false);
  const [reloadUsers, setReloadUsers] = useState<boolean>(false);
  const tableUserHeaders: string[] = ["Nome", "Email", "Telefone", "Privilégio"]
  const tableGroupHeaders: string[] = ["Nome", "Participantes", "Privilégio"]
  const [privilegesState, setPrivilegesState] = useState<{ state: StatePrivilegesTypes, id: string, permissionType: number }>({ state: "default", id: "", permissionType: -1 });
  const [organizationUsers, setOrganizationUsers] = useState<User[]>([]);
  const [itemUsers, setItemUsers] = useState<UserPermission[]>([]);
  const [itemGroups, setItemGroups] = useState<GroupPermission[]>([]);
  const [organizationGroups, setOrganizationGroups] = useState<Group[]>([]);
  const [newUserSearch, setNewUserSearch] = useState<string>("");
  const [newGroupSearch, setNewGroupSearch] = useState<string>("");
  const [permissionType, setPermissionType] = useState<number>(5);
  const [folderInfo, setFolderInfo] = useState<FolderInformation>({} as FolderInformation);
  const [reloadItem, setReloadItem] = useState<boolean>();
  const location = useLocation();
  const [isItemPage, setIsItemPage] = useState<boolean>(false);

  useEffect(() => {
    if (location.pathname.toLowerCase().includes("permissionuser")) {
      setIsItemPage(true);
    }
  }, [location])

  useEffect(() => {
    GetItem();
    GetAllUsersWorkspace();
    GetOrganizationUserByName();
    GetAllGroupsAsync();
    GetOrganizationGroupAsync();
    GetItemUsers();
    GetItemGroups();
    GetItemFolderInformation();
  }, [idFolder, targetType]);

  useEffect(() => {
    if (reloadUsers) {
      GetAllUsersWorkspace();
    }
  }, [reloadUsers]);

  useEffect(() => {
    if (targetType == PermissionTargetType.Group) {
      GetItem();
      GetAllUsersWorkspace();
      GetOrganizationUserByName();
      GetAllGroupsAsync();
      GetOrganizationGroupAsync();
      GetItemUsers();
      GetItemGroups();
      GetItemFolderInformation();
    }
  }, [targetType])

  useEffect(() => {
    if (reloadUsers) {
      GetAllUsersWorkspace();
    }
  }, [reloadUsers]);

  useEffect(() => {
    if (reloadItem) {
      GetItem().finally(() => setReloadItem(false));
    }
  }, [reloadItem]);

  useEffect(() => {
    if (searchFilter != "" && targetType == PermissionTargetType.User) {
      let filter = allUsersMemory.filter(user => user.userName.toLowerCase().includes(searchFilter.toLowerCase()));
      setAllUsersMemory(filter);
    } else {
      setAllUsersMemory(allUsers);
    }
  }, [searchFilter]);

  useEffect(() => {
    if (searchFilter != "" && targetType == PermissionTargetType.Group) {
      let filter = allGroupsMemory.filter(user => user.groupName.toLowerCase().includes(searchFilter.toLowerCase()));
      setAllGroupsMemory(filter);
    } else {
      setAllGroupsMemory(allGroups);
    }
  }, [searchFilter]);

  async function GetAllGroupsAsync() {
    setLoadingUsers(true);
    try {
      const response = await GetFolderGroupName(idFolder!, skip, limit, "");
      setAllGroups(response);
      setAllGroupsMemory(response);
    } catch (err: any) {
      setMessage(err.response.data);
      setSeverity("error");
    } finally {
      setLoadingUsers(false);
      setReloadUsers(false);
      setReloadItem(true);
    }
  }

  async function GetOrganizationGroupAsync() {
    setLoadingUsers(true);
    try {
      const response = await GetOrganizationGroup(nameOrg!, skip, limit);
      setOrganizationGroups(response);
    } catch (err: any) {
      setMessage(err.response.data);
      setSeverity("error");
    } finally {
      setLoadingUsers(false);
      setReloadItem(true);
    }
  }

  async function GetOrganizationUserByName() {
    try {
      const response = await GetOrganizationUserName(nameOrg!, newUserSearch);
      setOrganizationUsers(response);
    } catch (err: any) {
      setMessage(err.response.data);
      setSeverity("error");
    }
  }

  async function GetItemUsers() {
    try {
      const response = await GetItemUserAllName(idFolder!, skip, limit, newUserSearch);
      setItemUsers(response.permissions);
    } catch (err: any) {
      setMessage(err.response.data);
      setSeverity("error");
    }
  }

  async function GetItemGroups() {
    try {
      const response = await GetFolderGroupName(idFolder!, skip, limit, newUserSearch)
      setItemGroups(response);
    } catch (err: any) {
      setMessage(err.response.data);
      setSeverity("error");
    }
  }

  async function GetItem() {
    if (idFolder !== undefined) {
      setLoadingUsers(true);
      try {
        const response = await GetOneItem(idFolder);
        if (response == null) {
          setSeverity("error");
          setMessage("Não foi possivel recuperar o workspace.");
          navigate("/");
          throw new Error();
        }

        setItem(response);

      } catch (err: any) {
        setMessage(err.response.data);
        setSeverity("error");
      } finally {
        setLoadingUsers(false);
      }
    }
  }

  async function GetAllUsersWorkspace() {
    setLoadingUsers(true);
    if (idFolder !== undefined) {
      try {
        const response = await GetItemUser(idFolder, skip, limit)
        setAllUsers(usersFilter(response?.permissions));
        setAllUsersMemory(usersFilter(response?.permissions));
      } catch (err: any) {
        setMessage(err.response.data);
        setSeverity("error");
      } finally {
        setLoadingUsers(false);
        setReloadUsers(false);
        setReloadItem(true);
      }
    }
  }

  async function AddPermissionAsync() {
    setLoadingUsers(true);
    try {
      await AddPermissionUser({
        idObject: idFolder!,
        idUser: newUserSearch,
        permissionType: permissionType
      });
    } catch (err: any) {
      setMessage(err.response.data)
      setSeverity("error");
    } finally {
      backDefault();
      setLoadingUsers(false);
      setReloadUsers(true);
      setReloadItem(true);
    }
  }

  async function DeletePermission() {
    setLoadingUsers(true);
    try {
      await RemovePermissionUser({
        idObject: idFolder!,
        idUser: privilegesState.id,
        permissionType: privilegesState.permissionType
      });
    } catch(err: any) {
      setMessage(err.response.data);
      setSeverity("error");
    } finally {
      setPrivilegesState({ state: "default", id: "", permissionType: -1 });
      setLoadingUsers(false);
      setReloadUsers(true);
      setReloadItem(true);
      backDefault();
    } 
  }

   async function DeletePermissionGroup() {
    setLoadingUsers(true);
    try {
      await RemovePermissionGroup({
        idObject: idFolder!,
        idGroup: privilegesState.id,
        permissionType: privilegesState.permissionType
      });
    } catch(err: any) {
      setMessage(err.response.data);
      setSeverity("error");
    } finally {
      setPrivilegesState({ state: "default", id: "", permissionType: -1 });
      setLoadingUsers(false);
      setReloadUsers(true);
      setReloadItem(true);
      backDefault();
    } 
  }

  async function AddGroupPermissionAsync() {
    setLoadingUsers(true);
    try {
      await AddPermissionGroup({
        permissionType: permissionType!,
        idGroup: newGroupSearch,
        idObject: idFolder!
      });
    } catch (err: any) {
      setMessage(err.response.data);
      setSeverity("error");
    } finally {
      setLoadingUsers(false);
      backDefault();
      setReloadItem(true);
    }
  }

  async function GetItemFolderInformation() {
    try {
      const response = await GetFolderInformation(idFolder!);
      setFolderInfo(response);
    } catch {

    }
  }

  function handleUser(e: SelectChangeEvent): void {
    setNewUserSearch(e.target.value);
  }

  function handleGroup(e: SelectChangeEvent): void {
    setNewGroupSearch(e.target.value);
  }

  function usersFilter(response: UserPermission[]) {
    return response.filter(user => user.permissionType != 4);
  }

  function backDefault() {
    setPrivilegesState({ state: "default", id: "", permissionType: -1 });
    setNewUserSearch("");
    setPermissionType(5);
    GetAllUsersWorkspace();
    GetItem();
    setTargetType(PermissionTargetType.User);
  }

  return (
    <>
      { privilegesState.state == "default" && (
        <PrivilegesStateDefault 
          allUsersMemory={allUsersMemory}
          allGroupsMemory={allGroupsMemory}
          loadingUsers={loadingUsers}
          setSearchFilter={setSearchFilter}
          setTargetType={setTargetType}
          tableUserHeaders={tableUserHeaders}
          tableGroupHeaders={tableGroupHeaders}
          targetType={targetType}
          workspaceName={item?.name!}
          setPrivilegesState={setPrivilegesState}
          isItemPage={isItemPage}
          ownerId={item?.ownerId!}
          hasFolderChild={folderInfo?.fatherId !== undefined}
        />
      )}
      { privilegesState.state == "adding user" && (
        <PrivilegesStateAddingUser
        AddPermission={AddPermissionAsync}
          handleUser={handleUser}
          newUserSearch={newUserSearch}
          organizationUsers={organizationUsers}
          setPermissionType={setPermissionType}
          targetType={targetType}
          permissionType={permissionType}
          backBtn={backDefault}
          isItemPage={false}
        />
      ) }
      { privilegesState.state == "editing user" && (
        <PrivilegeStateEditingUser
          editPermission={AddPermissionAsync}
          handleUser={handleUser}
          newUserSearch={newUserSearch}
          organizationUsers={organizationUsers}
          setPermissionType={setPermissionType}
          permissionType={permissionType}
          setNewUserSearch={setNewUserSearch}
          privilegesState={privilegesState}
          userId={newUserSearch}
          backBtn={backDefault}
          isItemPage={isItemPage}
        />
      ) }
      { privilegesState.state == "adding group" && (
        <PrivilegesStateAddingGroups
          AddPermission={AddGroupPermissionAsync}
          handleUser={handleGroup}
          newGroupSearch={newGroupSearch}
          organizationGroups={organizationGroups}
          setPermissionType={setPermissionType}
          permissionType={permissionType}
          backBtn={backDefault}
          isItemPage={isItemPage}
        />
      ) }
      { privilegesState.state == "editing group" && (
        <PrivilegeStateEditingGroup
          editPermission={AddGroupPermissionAsync}
          handleGroup={handleGroup}
          newGroupSearch={newGroupSearch}
          organizationGroup={organizationGroups}
          setPermissionType={setPermissionType}
          permissionType={permissionType}
          setNewGroupSearch={setNewGroupSearch}
          privilegesState={privilegesState}
          groupId={newGroupSearch}
          backBtn={backDefault}
          isItemPage={isItemPage}
        />
      ) }
      <KeyDriveDialog 
        keyDriveDialogContent={{
          dialogTitle: "Deseja realmente deletar esta permissão?",
          dialogContent: "Ao deletar a permissão, o usuário será removido do workspace e das pastas que ele possui permissões",
          openDialog: privilegesState.state == "deleting permission",
          dialogIcon: <Delete />,
          handleTogglDialog: () => {}
        }}
        keyDriveDialogButtons={{
          rightButtonText: "Confirmar",
          leftButtonText: "Cancelar",
          rightButtonMethod: () => { targetType == PermissionTargetType.User ? DeletePermission() : DeletePermissionGroup() },
          leftButtonMethod: () => { setPrivilegesState({ id: "", permissionType: -1, state: "default" }) }
        }}
        dialogTitleCenter
      />
      <KeydriveSnackbar 
        message={message}
        open={message != undefined}
        onClose={() => {
          setMessage(undefined);
        }}
        variant={severity}
      />
    </>
  );
};


export default PermissionUserFolder;
